var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[_c('h1',[_vm._v("Welcome "+_vm._s(_vm.user))]),_c('button',{staticClass:"btn2",on:{"click":_vm.logOut}},[_vm._v("Logout")])])}
var staticRenderFns = []

export { render, staticRenderFns }